import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from '../i18n';

/**
 * NotFoundPage — designed 404 (replaces the silent redirect to /library).
 * MUBI single-hero tone: 96px serif italic § Lost. + lead + accent CTA.
 */
export default function NotFoundPage() {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <main className="container not-found-page">
      <div className="not-found-mark" aria-hidden="true">§</div>
      <div className="kicker not-found-kicker">{t('notFound.kicker')}</div>
      <h1 className="not-found-title">
        {t('notFound.titleLine1')} <em>{t('notFound.titleLine2')}</em>
      </h1>
      <p className="not-found-lead">
        {t('notFound.lead')}
      </p>
      <p className="not-found-path" aria-label={t('notFound.pathLabel')}>
        <code>{location.pathname}</code>
      </p>
      <div className="not-found-actions">
        <Link to="/library" className="btn btn-accent">
          {t('notFound.cta')} <span className="arrow">→</span>
        </Link>
        <Link to="/credentials" className="btn btn-secondary">
          {t('nav.credentials')}
        </Link>
      </div>
    </main>
  );
}
